import { ModalProps } from '../../../services/modals.service';
import React from 'react';
import { AlertService } from '../../../services/alert.service';
import { useModalClose } from '../../../utils/useModalClose';

interface Props extends ModalProps {
  bitrixLinkCode: string;
}

export const getRegistrationBitrixMessage = (bitrixLinkCode: string) => {
  return `Здравствуйте!
Администратор добавил ваc в систему Express Today.
Чтобы получить доступ к личному кабинету, войдите по ссылке ниже:
👉 https://my.express-today.ru/login/bitrix/${bitrixLinkCode}`;
};

export const BitrixMessageUserModal = ({ bitrixLinkCode, close }: Props) => {
  const modalRef = useModalClose(close);

  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>
            Сообщение для клиента{' '}
            <i
              className="bi bi-clipboard cursor-pointer"
              onClick={() => {
                navigator.clipboard
                  .writeText(getRegistrationBitrixMessage(bitrixLinkCode))
                  .then(() => {
                    AlertService.success();
                  });
              }}
            />
          </h3>
        </div>

        <div className="modal-body text-center">
          <div>
            <div className={'d-flex gap-2'}></div>
            <textarea
              style={{ height: '200px' }}
              className={'form-control mb-3 '}
              disabled={true}
              value={getRegistrationBitrixMessage(bitrixLinkCode)}
            />
          </div>

          <button
            type="button"
            className="btn btn-light mt-4 w-100"
            onClick={() => close()}
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
};
